import React, { Fragment } from 'react'
import { Carousel, } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons';
import './style.css'
export default function StationNet(props) {
    const { data } = props;
    const systemList = data.systemList;
    const systemListLength = systemList.length - 1;
    const carouselList = data.carouselList;
    return (
        <div className='StationNet'>
            <img className='StationNet_Background' 
            // src='images/HomePage/StationNet/1.png'
            style={{background: `linear-gradient(0deg, rgba(0, 114, 229, 0.5), rgba(0, 114, 229, 0.5)),
            radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)
            , url('images/HomePage/StationNet/bg-img.png')`,backgroundSize:'100% 100%'}}
            // 'images/HomePage/StationNet/1.png'
            />
            <div className='StationNetMain'>
                <div className='StationNet_Top'>
                    <div className='StationNet_TopTitle'>真实性检验场网</div>
                    <div className='StationNet_TopTitleBottom' />
                    <div className='StationNet_TopIntroduce'>依托现有观测站网建设，在全国范围内选择一定数量典型区域的观测场、站，天地一体化同步观测采集相关数据，实现产品与算法的质量与稳定度检验，支撑基于自主遥感数据的算法研发并对卫星应用效能进行评价。</div>
                </div>
                <div className='StationNet_Bottom'>
                    <div className='StationNet_BottomLeft'> 
                        <img className='StationNet_BottomLeftImg' src='images/HomePage/StationNet/leftImg.png'/>
                        {systemList.map((system, index) => {
                            return (
                                <Fragment>
                                    <div className='StationNet_System'>
                                        <div className='StationNet_SystemLeft'>
                                            <img className='StationNet_SystemImg' src={system.img}/>
                                            {/* <img className='StationNet_SystemIcon' /> */}
                                        </div>
                                        <div className='StationNet_SystemRight'>
                                            <div className='StationNet_SystemTitle'>{system.title}</div>
                                            <div className='StationNet_SystemIntroduce'>{system.introduce}</div>
                                        </div>
                                    </div>
                                    {systemListLength !== index ? <div className='StationNet_SystemBottomLines'>
                                        <div className='StationNet_SystemBottomLine' />
                                        <div className='StationNet_SystemBottomPoint' />
                                    </div> : null}
                                </Fragment>
                            )
                        })}
                    </div>
                    <div className='StationNet_BottomRight'>
                        <Carousel autoplay={true} autoplaySpeed={5000} speed={1000} infinite>
                            {carouselList.map((item) => {
                                return (
                                    <div className='StationNet_CarouselItem'>
                                        <div className='StationNet_CarouselLeft'>
                                            <div className='StationNet_CarouselLeftTop'>
                                                <div className='StationNet_CarouselCN'>卫星共性应用支撑平台</div>
                                                <div className='StationNet_CarouselEN'>Featured in</div>
                                            </div>
                                            <div className='StationNet_CarouselLeftBottom'>
                                                <div className='StationNet_CarouselNum'>{item.num}</div>
                                                <div className='StationNet_CarouselTitle'>{item.title}</div>
                                                <div className='StationNet_CarouselIntroduce'>{item.introduce}</div>
                                            </div>
                                        </div>
                                        <div className='StationNet_CarouselRight'>
                                            <img className='StationNet_CarouselImg' src={item.img}/>
                                        </div>
                                    </div>
                                )
                            })}
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
    )
}